import SummaryTabContentLoadingSkeleton from './SummaryTabContentLoadingSkeleton'

export default SummaryTabContentLoadingSkeleton
